import React, { useEffect, useState } from 'react'
import CustomDraggable from 'Common/CustomDraggable/CustomDraggable'
import ReactPortal from 'Components/ReactPortal/ReactPortal'
import useDebounce from 'CustomHooks/useDebounce'
import api from 'http'
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage'
import { toast } from 'react-toastify'
import FullPageLoader from 'Components/FullPageLoader/FullPageLoader'
import PopupFooter from 'Components/PopupFooter/PopupFooter'
import PopupHeader from 'Components/PopupHeader/PopupHeader'
import ConfirmationPopup from 'Popups/ConfirmationPopup/ConfirmationPopup'
import isNull from 'Utils/isNull'

const MergePatientPopup = ({ onClose, patientId }) => {
    const uniqueId = "MergePatientPopup"
    const genders = {
        M: 'Male',
        'F': 'Female'
    }
    const [inputValue, setInputValue] = useState("")
    const [patientsList, setPatientsList] = useState([])
    const [isLoading, setIsLoading] = useState(false)
      const [showOverridePopup, setShowOverridePopup] = useState({
        status:false,
        massage:"",
        id:0
      })
    const debouncedSearchTerm = useDebounce(inputValue, 500);
    const overridePopupClose = () => {
        setShowOverridePopup({ status: false, massage: "",id:0 })
    }
    const handleAddNew = async (selectedPat,status=false) => {
        try {
            setIsLoading(true)

            // const searchApi = mode === "merge" ? "MergePatients" : "UndoMergePatient"
            const response = await api.get(`${process.env.REACT_APP_TC_PMS}/api/Patient/MergePatients?targetPatientId=${patientId}&sourcePatientId=${selectedPat.id}&OverrideToMergePatientStatement=${status}`,);
            toast.success(response.data.responseMessage)
            onClose(selectedPat.id)
        } catch (error) {
            const isError = error.response.data?.dataModel?.overrideToMergePatientStatement
            isError && setShowOverridePopup({ status: true, massage: error.response.data.responseMessage, id: selectedPat.id });
            !isError && ErrorHandlingMessage(error);
        } finally { setIsLoading(false) }
    }
    useEffect(() => {
        if (debouncedSearchTerm.length >= 2) {
            (async () => {
                try {
                    setIsLoading(true)
                    const response = await api.get(`${process.env.REACT_APP_TC_PMS}/api/Patient/PatientSuperSearch/${debouncedSearchTerm}`);
                    setIsLoading(false)
                    setPatientsList(response.data.dataModel.data)
                } catch (error) {
                    setIsLoading(false)
                    ErrorHandlingMessage(error)
                    setPatientsList([])
                }
            })();
        }
        else {
            setPatientsList([])
        }
    }, [debouncedSearchTerm, patientId])
    return (
        <ReactPortal wrapperId={uniqueId}>
            {showOverridePopup.status && (
                <ConfirmationPopup
                    onConfirm={() => handleAddNew(showOverridePopup, true)}
                    onCancel={overridePopupClose}
                    buttonTitle="Yes"
                    heading="Confirmation"
                    subHeading={<pre>{showOverridePopup.massage}</pre>}
                />
            )}

            {isLoading && <FullPageLoader allowFullScreen />}
            <div data-te-modal-init className="fixed inset-0 z-10 flex items-center justify-center bg-gray-500 bg-opacity-75" id="exampleModalScrollable" tabIndex={-1} aria-labelledby="exampleModalScrollableLabel" aria-modal="true" data-te-open="true">
                <CustomDraggable handle={`#${uniqueId}`}>
                    <div data-te-modal-dialog-ref className="relative w-[1400px]   min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] flex flex-col overflow-hidden rounded-md bg-white shadow-lg">
                        <div className='p-10 pt-0 '>
                            <PopupHeader uniqueId={uniqueId} heading="Merge Patient" />
                            <div className="grid grid-cols-12 mb-3 ">
                                <div className='flex items-center col-span-9 px-2 font-semibold'>Patients List</div>
                                <div className='relative flex items-center col-span-3 px-2'>

                                    <img src="/img/search.svg" alt="cross" className='absolute w-6 pl-1 left-3' />
                                    <input value={inputValue} onChange={(e) => setInputValue(e.target.value)} placeholder='Search...' className='w-full px-2 py-2 bg-[#E3E3E3] rounded-md outline-none pl-[28px]' type="search" />
                                </div>
                            </div>
                            <div className="overflow-y-auto max-h-[70vh]">
                                <div className="grid grid-cols-12">
                                    <div className='col-span-12 '>
                                        <div className="flex flex-col">
                                            <div className="overflow-x-auto ">
                                                <div className="inline-block min-w-full py-2 ">
                                                    <div className="overflow-hidden">
                                                        <table className="min-w-full text-sm font-light text-left">
                                                            <thead className="font-medium  bg-[#F5F5F5] text-[#3B3B3B]">
                                                                <tr>
                                                                    <th scope="col" className="py-4 px-7 ">Patient</th>
                                                                    <th scope="col" className="py-4 px-7 ">DOB</th>
                                                                    <th scope="col" className="py-4 px-7 ">Gender</th>
                                                                    <th scope="col" className="py-4 px-7 ">Account</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {patientsList.map((pat) => {
                                                                    return (
                                                                        <tr key={pat.id} className="border-b dark:border-neutral-500">
                                                                            <td className="py-4 font-medium px-7 whitespace-nowrap">
                                                                                <span onClick={() => handleAddNew(pat)} className='font-semibold cursor-pointer hover:text-primary hover:underline'>   {pat.name}</span>
                                                                            </td>
                                                                            <td className="py-4 px-7 whitespace-nowrap">{pat.dob}</td>
                                                                            <td className="py-4 px-7 whitespace-nowrap">{genders[pat.gender] || 'Unknown'}</td>
                                                                            <td className="py-4 px-7 whitespace-nowrap">{pat.accountNum}</td>
                                                                        </tr>
                                                                    )
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <PopupFooter onClose={() => onClose(false)} />
                        </div>
                    </div>
                </CustomDraggable>
            </div>
        </ReactPortal>

    )
}

export default MergePatientPopup